import type { AdditionalCostType } from '@api'
import type { ColumnDef } from '@tanstack/react-table'

import { Skeleton } from '@/components/ui/skeleton'
import { DataTable } from '@/components/ui/table/data-table'

interface AccountingAdditionalCostTypesTableSkeletonProps {
  columns: ColumnDef<AdditionalCostType>[]
}

export const AccountingAdditionalCostTypesTableSkeleton = ({
  columns,
}: AccountingAdditionalCostTypesTableSkeletonProps) => {
  const skeletonColumns = columns.map((column) => ({
    ...column,
    cell: () => (
      <Skeleton className="h-4 w-20 !bg-slate-300 dark:!bg-slate-700" />
    ),
  })) as ColumnDef<unknown>[]

  return (
    <DataTable
      hasActionColumn
      title="Additional Costs Types"
      columns={skeletonColumns}
      data={Array.from({ length: 10 }).map(() => '')}
    />
  )
}
